import { useEffect } from 'react';
import type { Stage } from '@eventbrite/webapp-constants';

// Values from https://github.com/eventbrite/eb-ui/blob/main/packages/infra/real-user-monitoring/src/utils/rum.ts#L75
const DATADOG_CONFIG = {
  APPLICATION_ID: '1429889f-7c31-4b1d-a280-e94ec0704262',
  CLIENT_TOKEN: 'pubf43fcf8de511ce458f04cbdf8dc2deb6',
  SITE: 'datadoghq.com' as const,
  SERVICE: 'rum-web--listings-webapp',
  VERSION: '0.1.0',
  SESSION_SAMPLE_RATE: 0.15,
};

let initialized = false;

const initializeDatadogRum = async (stage: Stage) => {
  if (initialized) return;

  const { datadogRum } = await import('@datadog/browser-rum-slim');
  datadogRum.init({
    applicationId: DATADOG_CONFIG.APPLICATION_ID,
    clientToken: DATADOG_CONFIG.CLIENT_TOKEN,
    site: DATADOG_CONFIG.SITE,
    service: DATADOG_CONFIG.SERVICE,
    env: stage,
    version: DATADOG_CONFIG.VERSION,
    sessionSampleRate: DATADOG_CONFIG.SESSION_SAMPLE_RATE,
    trackUserInteractions: true,
  });
  initialized = true;
};

export const DatadogInit = ({ stage }: { stage: Stage }) => {
  useEffect(() => {
    const initDatadogRum = async () => {
      await initializeDatadogRum(stage);
    };
    initDatadogRum().catch((error) => {
      console.error('Error initializing Datadog:', error);
    });
  }, []);

  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
};
